import { makeAutoObservable } from 'mobx'

import { worksheetController } from '@/controller/worksheet.controller'

export type WorksheetDesignTemplateT = res.WorksheetDesignTemplate

class DesignTemplateService {
  worksheetDesignTemplateList: res.WorksheetDesignTemplate[] = []

  constructor() {
    makeAutoObservable(this)
  }

  async fetchAllDesignTemplateList() {
    const [worksheetDesignTemplate] = await Promise.all([worksheetController.fetchDesignTemplate()])

    this.worksheetDesignTemplateList = worksheetDesignTemplate.sort((x, y) => x.index - y.index)
  }
}

const designTemplateService = new DesignTemplateService()
export default designTemplateService
